import * as t from "io-ts";
import { BadResponseBodyError } from "../../../bad-response-body-error";
import { FormId } from "../../../types/ids";

export const TrackingEvent = t.union([
  t.literal("view"),
  t.literal("start"),
  t.literal("submit")
]);

export const SendTrackingRequest = t.type({
  id: FormId,
  event: TrackingEvent,
});
export type SendTrackingRequest = t.TypeOf<typeof SendTrackingRequest>;

export const SendTrackingResponse = t.type({
  success: t.boolean,
});
export type SendTrackingResponse = t.TypeOf<typeof SendTrackingResponse>;
export type SendTrackingResponseOutput = t.OutputOf<typeof SendTrackingResponse>;

export async function trackFormHandler({ id, event }: SendTrackingRequest): Promise<SendTrackingResponse> {
  const res = await fetch("/api/tracking/forms/t", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(SendTrackingRequest.encode({ id, event })),
  });
  
  return BadResponseBodyError.throwIfLeft(res.status, 
    SendTrackingResponse.decode(await res.json()));
}
